var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.halfs(),"item-text":"value","item-value":"key","menu-props":"auto","placeholder":"Wybierz nabór","single-line":""},model:{value:(_vm.halfSelected),callback:function ($$v) {_vm.halfSelected=$$v},expression:"halfSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }